import { render, staticRenderFns } from "./Abnormal.vue?vue&type=template&id=b77a1306&scoped=true&"
import script from "./Abnormal.vue?vue&type=script&lang=js&"
export * from "./Abnormal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b77a1306",
  null
  
)

export default component.exports